import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import ReactPaginate from "react-paginate";
import { jwtDecode } from "jwt-decode"; // Importation corrigée

import Ecran from "../menuEcran/ecran";
import InfoPublication from "./infoPublication";
import { baseApiUrl } from "../../../services/api";




function Liste() {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [projectsPerPage] = useState(6); // Nombre de projets par page
  const [category, setCategory] = useState("Toutes");
  const [publications, setPublications] = useState([]); // État pour stocker les publications
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur
  const navigate = useNavigate();

  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get(
        "/categorie/liste"
      );
      const options = response.data.map((category) => ({
        value: category.id,
        label: category.nom,
      }));
      setCategoriesOptions(options);
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
    }
  };

  // Fonction pour récupérer les publications actives ou d'une catégorie spécifique
  const fetchPublications = async (idCategorie = null) => {
    try {
      const url = idCategorie
        ? `/publication/categorie/${idCategorie}`
        : "/publication/liste";
      const response = await baseApiUrl.get(url);

      // Filtrer les publications actives
      const filteredPublications = response.data.filter(
        (publication) => publication.actif === true
      );
      setPublications(filteredPublications);
      console.log("Publications récupérées :", filteredPublications);
    } catch (error) {
      console.error("Erreur lors de la récupération des publications :", error);
    }
  };

  // Utilisation de useEffect pour initialiser les données
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté :", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token :", error);
      }
    }

    fetchCategories();
    fetchPublications(); // Charger toutes les publications actives par défaut
  }, []);

  // Fonction pour gérer la sélection d'une catégorie
  const handleCategorySelection = (selectedCategory) => {
    setCategory(selectedCategory);

    if (selectedCategory === "Toutes") {
      fetchPublications(); // Récupérer toutes les publications actives
    } else {
      // Trouver l'ID de la catégorie sélectionnée
      const categoryOption = categoriesOptions.find(
        (cat) => cat.label === selectedCategory
      );
      if (categoryOption) {
        fetchPublications(categoryOption.value); // Récupérer les publications de la catégorie
      }
    }
  };

 
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

 
  // Filtrer les publications par le terme de recherche
  const filteredPublications = publications.filter(
    (publication) =>
      publication.titre &&
      publication.titre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const offset = currentPage * projectsPerPage;
  const currentPublications = filteredPublications.slice(
    offset,
    offset + projectsPerPage
  );
  return (
    <div className="liste">
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1>Publications</h1>
                <h3 style={{ fontSize: "18px", color: "white" }}>
                  Une publication est une initiative planifiée qui vise à atteindre un objectif précis en mobilisant des ressources et des compétences. Il peut concerner divers domaines comme la technologie, l'entrepreneuriat, la recherche ou le développement social.
                </h3>
              </div>
            </div>
          </div>
          {/* <Ecran /> */}
        </div>
      </div>

      <div className="blog1 sp bg1 _relative">
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="col-lg-10 m-auto text-center">
                <div className="categories-buttons">
                  <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${category === "Toutes" ? "active" : ""}`}
                        onClick={() => handleCategorySelection("Toutes")}
                        id="category-tab1-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#category-tab1"
                        type="button"
                        role="tab"
                        aria-controls="category-tab1"
                        aria-selected={category === "Toutes"}
                      >
                        Tous
                      </button>
                    </li>
                    {categoriesOptions.map((cat) => (
                      <li className="nav-item" role="presentation" key={cat.value}>
                        <button
                          className={`nav-link ${category === cat.label ? "active" : ""}`}
                          onClick={() => handleCategorySelection(cat.label)}
                          id={`category-tab${cat.value}-tab`}
                          data-bs-toggle="pill"
                          data-bs-target={`#category-tab${cat.value}`}
                          type="button"
                          role="tab"
                          aria-controls={`category-tab${cat.value}`}
                          aria-selected={category === cat.label}
                        >
                          {cat.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="tab-content categories-content-tab">
                <div
                  className="tab-pane fade show active"
                  role="tabpanel"
                  aria-labelledby="category-tab1-tab"
                >
                  <div className="blog1-posts-area">
                    <div className="row">
                      {currentPublications.map((publication, index) => (
                        <InfoPublication key={index} publication={publication} categoriesOptions={categoriesOptions} />
                      ))}
                    </div>

                    <div className="space60"></div>
                    <div className="row" data-aos-offset="50" data-aos-duration="400">
                      <div className="col-12 m-auto">
                        <div className="theme-pagination text-center">
                          <ReactPaginate
                            previousLabel={<i className="fa-solid fa-angle-left"></i>}
                            nextLabel={<i className="fa-solid fa-angle-right"></i>}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(filteredPublications.length / projectsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer1 />
      <Footer />
      </div>

      
  );
}

export default Liste;
